import { PlatformRequestData, PlatformRequestStatus, RequestType } from '@markant-platform/registration/model';
import { Industry, OrganizationType, QualificationLevel, SalutationType } from 'data-model';

export const MOCK_REGISTRATION_REQUEST: PlatformRequestData = {
  id: 'requestId',
  type: RequestType.REGISTRATION_REQUEST,
  admins: [
    {
      userId: 'adminUserId',
      salutation: SalutationType.m,
      firstname: 'ash',
      lastname: 'ketchum',
      email: 'ash.ketchum@gottagetthemall.com',
    },
    {
      userId: 'adminUserId2',
      salutation: SalutationType.m,
      firstname: 'peter',
      lastname: 'fox',
      email: 'peter.fox@gottagetthemall.com',
    },
  ],
  comments: [],
  user: {
    salutation: SalutationType.m,
    firstname: '',
    lastname: '',
    email: 'hello@world.pt',
    language: '',
    platformTermsOfUseTimestamp: '2024-03-11T16:02:10.011Z',
  },
  organization: {
    organizationId: 'id',
    name: 'org-name',
    address: {
      street: 'org-street',
      streetNumber: '12',
      zipCode: '4200',
      city: 'Porto',
      countryCode: 'PT',
    },
    gln: null,
    industry: null,
    salesTaxId: null,
    taxNumber: '132132',
    ezrCustomer: null,
    commercialRegisterId: '',
    organizationType: OrganizationType.SUPPLIER,
    targetQualificationLevel: QualificationLevel.LEVEL_3,
    phone: '+1232425',
  },
  originalOrganizationData: {
    organizationId: 'id',
    name: 'original org name',
    address: {
      street: 'original org street',
      streetNumber: 'original org street number',
      zipCode: 'original org zip code',
      city: 'original org city',
      countryCode: 'original org country',
    },
    gln: 'original org gln',
    industry: Industry.SUPPLIER,
    salesTaxId: 'original org sales tax id',
    taxNumber: 'original org sales tax number',
    ezrCustomer: true,
    commercialRegisterId: 'original org commercial register id',
    organizationType: OrganizationType.SUPPLIER,
    targetQualificationLevel: QualificationLevel.LEVEL_3,
    phone: 'original org phone number',
  },
  platformRequestStatus: PlatformRequestStatus.PENDING,
  version: 0,
};
